<div *ngIf="selectedDoc; else notFound"
     class="flex flex-col text-[#1F2937] dark:text-gray-200">

  <!-- ===== Main Title & Description ===== -->
  <section class="my-8">
    <h1 class="text-[#1F2937] dark:text-white text-4xl md:text-5xl font-black leading-tight mb-6">
      {{ firstHeader?.data?.text || (selectedDoc.project?.name + ' Document') }}
    </h1>

    <p class="text-gray-600 dark:text-gray-400 text-lg" *ngIf="firstParagraph">
      {{ firstParagraph.data.text }}
    </p>
  </section>

  <!-- ===== Main Layout (Sidebar + Content) ===== -->
  <section class="flex flex-col md:flex-row gap-10">
    
    <!-- ===== Sidebar ===== -->
    <div class="md:w-[25%] w-full border-r border-gray-200 dark:border-gray-700 pr-6">
      <h2 class="text-xl font-semibold mb-4 text-[#1F2937] dark:text-gray-100">Contents</h2>
      <ul class="flex flex-col gap-2">
        <li *ngFor="let section of contentSections; let i = index"
            (click)="setActiveSection(i)"
            class="cursor-pointer rounded-md px-3 py-2 text-sm font-medium transition-all duration-200"
            [ngClass]="{
              'bg-blue-50 text-blue-600 font-semibold shadow-sm': activeSectionIndex === i,
              'text-[#1F2937] dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700/50': activeSectionIndex !== i
            }">
          {{ section.question }}
        </li>
      </ul>
    </div>

    <!-- ===== Content Area ===== -->
    <div class="md:w-[75%] w-full space-y-10">
      <ng-container *ngIf="contentSections.length > 0">
        <ng-container *ngFor="let section of contentSections; let i = index">
          <div *ngIf="activeSectionIndex === i" class="space-y-6">
            
            <!-- Question (Unordered list item) -->
            <h3 class="text-2xl font-bold text-[#1F2937] dark:text-white">
              {{ section.question }}
            </h3>

            <!-- Answer (Ordered steps) -->
            <ul *ngIf="section.steps?.length"
                class="list-decimal pl-6 space-y-2 text-base leading-relaxed text-[#374151] dark:text-gray-300">
              <li *ngFor="let step of section.steps">{{ step }}</li>
            </ul>

            <!-- Image -->
            <div *ngIf="section.image" class="flex flex-col items-center my-6">
              <img [src]="section.image"
                   alt="Document Image"
                   class="rounded-xl shadow-md border border-gray-200 dark:border-gray-700 max-w-full w-auto" />
            </div>

          </div>
        </ng-container>
      </ng-container>
    </div>
  </section>
</div>

<!-- ===== Not Found ===== -->
<ng-template #notFound>
  <p class="text-center text-gray-600 dark:text-gray-400 mt-10">
    Document not found for this project.
  </p>
</ng-template>

<!-- 🔙 Back Button -->
<button
  class="w-fit bg-primary text-white font-semibold py-2 px-6 rounded-lg hover:bg-primary/90 transition"
  (click)="goBack()">
  ← Back to Documents
</button>
